import { createActionColumn } from "@components/shared/actionColumn";
import { deleteAttendance } from "@services/api";
import { Direction } from "@local-types/direction/tableRow";

export const getColumnDefs = (
  hasAmount: boolean,
  hasIsPaid: boolean,
  handleCellValueChanged: (params: any) => Promise<void>,
  handleDeleteSuccess: () => Promise<void>,
  directions: Direction[],
) => {
  // Подготовим данные для выпадающего списка
  const directionNames = ["", ...directions.map((d) => d.name)];
  const directionIdByName = Object.fromEntries(
    directions.map((d) => [d.name, d.id]),
  );
  const directionNameById = Object.fromEntries(
    directions.map((d) => [d.id, d.name]),
  );

  var res = [
    {
      headerName: "ID",
      field: "id",
      sortable: true,
      width: 80,
      suppressMovable: true,
      resizable: false,
    },
    {
      headerName: "Имя участника",
      field: "participant_name",
      sortable: true,
      filter: true,
      resizable: false,
      width: 200,
      suppressMovable: true,
    },
    {
      headerName: "Направление",
      field: "direction_id",
      sortable: true,
      filter: true,
      resizable: false,
      editable: true,
      width: 200,
      suppressMovable: true,
      valueFormatter: (params: any) => {
        if (params.value === undefined || params.value === null) return "";
        return directionNameById[params.value] || params.value;
      },
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: directionNames,
      },
      valueParser: (params: any) => {
        // params.newValue - выбранное название направления
        const directionName = params.newValue;
        if (directionName === "") return null;
        return directionIdByName[directionName] || null;
      },
      onCellValueChanged: handleCellValueChanged,
    },
    {
      headerName: "Сумма",
      field: "amount",
      sortable: true,
      filter: false,
      resizable: false,
      editable: true,
      width: 80,
      suppressMovable: true,
      onCellValueChanged: handleCellValueChanged,
    },
    {
      headerName: "Дата",
      field: "date",
      sortable: true,
      sort: "desc",
      filter: true,
      resizable: false,
      editable: true,
      width: 120,
      flex: 1,
      suppressMovable: true,
      onCellValueChanged: handleCellValueChanged,
    },
    {
      headerName: "Платное",
      field: "is_paid",
      sortable: true,
      filter: false,
      resizable: false,
      editable: true,
      valueFormatter: (params: any) => (params.value === 1 ? "Да" : "Нет"),
      width: 100,
      suppressMovable: true,
      onCellValueChanged: handleCellValueChanged,
    },
    createActionColumn({
      icon: "X",
      type: "delete",
      onClick: (data) => {
        if (
          window.confirm(
            `Вы хотите удалить посещение для строки ${data.id}. Это действие нельзя будет отменить. Вы точно хотите безвозвратно удалить эту строку?`,
          )
        ) {
          deleteAttendance(data.id)
            .then(() => {
              handleDeleteSuccess();
            })
            .catch((error) => {
              console.error("Ошибка:", error);
              alert("Ошибка удаления посещения");
            });
        }
      },
    }),
  ];

  res = hasAmount ? res : res.filter((r) => r.headerName !== "Сумма");
  res = hasIsPaid ? res : res.filter((r) => r.headerName !== "Платное");

  return res;
};
